import { Box, Button, Collapse } from '@mantine/core'
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react'
import { PropsWithChildren, ReactNode } from 'react'

type CodeExampleToggleProps = PropsWithChildren<{
  buttonLabel: ReactNode
  isOpen: boolean
  onClick: () => void
}>

export const CodeExampleToggle = ({
  children,
  buttonLabel,
  isOpen,
  onClick
}: CodeExampleToggleProps) => {
  return (
    <div>
      <Button
        variant="outline"
        size="compact-xs"
        rightSection={
          isOpen ? <IconChevronUp size={14} /> : <IconChevronDown size={14} />
        }
        onClick={onClick}
      >
        {buttonLabel}
      </Button>

      <Collapse in={isOpen}>
        <Box mt="xs">{children}</Box>
      </Collapse>
    </div>
  )
}
